import { Box, Container, Flex, Text, Badge, Spinner, useColorModeValue } from '@chakra-ui/react';
import useTmr from '../../hooks/useTmr';

function formatCurrency(value) {
  return value.toLocaleString('es-CO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function TmrBar() {
  const { value, deltaPercent, updatedAt, loading } = useTmr();
  const isUp = deltaPercent >= 0;
  const sign = isUp ? '+' : '';
  const bgColor = useColorModeValue('rgba(255, 255, 255, 0.95)', 'dark.900');
  const borderColor = useColorModeValue('tint.200', 'dark.700');
  const subtleTextColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box borderTop="1px solid" borderColor={borderColor} bg={bgColor}>
      <Container maxW="1120px">
        <Flex
          align="center"
          justify="center"
          gap={3}
          py={2}
          fontSize="sm"
          flexWrap="wrap"
        >
          {loading ? (
            <Flex align="center" gap={2}>
              <Spinner size="sm" color="brand.500" />
              <Text color={subtleTextColor}>Cargando TMR...</Text>
            </Flex>
          ) : (
            <>
              <Text fontWeight="600">
                TMR Actual (USD/COP): ${formatCurrency(value)}
              </Text>
              {deltaPercent !== 0 && (
                <Badge
                  px={3}
                  py={1}
                  borderRadius="full"
                  fontWeight="700"
                  fontSize="xs"
                  bg={isUp ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'}
                  color={isUp ? 'green.300' : 'red.300'}
                  border="1px solid"
                  borderColor={isUp ? 'rgba(16, 185, 129, 0.4)' : 'rgba(239, 68, 68, 0.4)'}
                >
                  {sign}{deltaPercent.toFixed(2)}%
                </Badge>
              )}
              <Text color={subtleTextColor}>Actualizado: {updatedAt}</Text>
            </>
          )}
        </Flex>
      </Container>
    </Box>
  );
}

export default TmrBar;
